import { render } from "./trip.vue?vue&type=template&id=c9510b9c&scoped=true"
import script from "./trip.vue?vue&type=script&lang=js"
export * from "./trip.vue?vue&type=script&lang=js"

import "./trip.vue?vue&type=style&index=0&id=c9510b9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c9510b9c"

export default script